import Vue from "vue";

import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    //登录次数太多显示的弹框
    manyloginToast: false,
    //接口报错的提示
    isToastshow: false,
    message: "",
    bgcisshow1: 0,
    //协议对话框提示
    protocolDialogVisible:false,
    isProtocolLogin:false,
    //拼图
    isShowSliderVerify:false,
    sliderResult:false,
  },
  mutations: {
    //多次登录绑定弹窗
    manyLoginToastshow(state) {
      state.manyloginToast = true;
    },
    manyloginToastHidden(state) {
      state.manyloginToast = false;
    },
    //协议对话框
    protocolDialogshow(state) {
     
      state.protocolDialogVisible = true;
     
    },
    protocolDialogHidden(state) {
      state.protocolDialogVisible = false;
    },
    isProtocolLoginYes(state){
      state.protocolDialogVisible = false;
      state.isProtocolLogin=true
    },
    isProtocolLoginNo(state){
      state.isProtocolLogin=false
    },
    //错误提示弹窗
    toastshow(state, payload) {
      state.message = payload;
      state.isToastshow = true;
    },
    toastHidden(state) {
      state.isToastshow = false;
      state.message = "";
    },
    bgcisshow(state, payload) {
      state.bgcisshow1 = payload;
    },
    isShowSliderVerifyHandle(state,payload){
    
      state.isShowSliderVerify=payload
    },
    sliderResultHandle(state,payload){
      state.sliderResult = payload
     
      if(payload){
        state.isShowSliderVerify = false
      }
    }
  },
  actions: {},
});
